import { useQuery } from '@apollo/client';
import React from 'react';

import { Select, SelectOption } from '@flixbus/honeycomb-react';

import { ALL_GROUPS_ID } from 'pages/CrewTimeline/components/TimeLineFilter/const';
import { FETCH_CREW_MEMBER_GROUPS } from 'pages/CrewTimeline/components/TimeLineFilter/qql/getCrewMemberGroups';

import { ALL_GROUPS_OPTION } from './const';

const GroupSearch = ({ fieldControl, submitOnChange }) => {
	const { data, loading, error } = useQuery(FETCH_CREW_MEMBER_GROUPS);

	const renderOptions = (groups) => {
		if (!groups || groups.length === 0) return [];
		const allGroups = [{ id: ALL_GROUPS_ID, name: ALL_GROUPS_OPTION }, ...groups];
		return allGroups.map(({ id, name }) => {
			return (
				<SelectOption key={id} value={id}>
					{name}
				</SelectOption>
			);
		});
	};

	const handleOnSelect = (e) => {
		const value = e.target.value === ALL_GROUPS_ID ? '' : e.target.value;
		fieldControl.onChange(value);
		submitOnChange();
	};

	const currentValue = fieldControl.value || ALL_GROUPS_ID;

	return (
		<Select
			disabled={loading || !!error}
			id="groups"
			label="Group"
			value={currentValue}
			onChange={(e) => handleOnSelect(e)}
		>
			{renderOptions(data?.crewMemberGroups)}
		</Select>
	);
};

export default GroupSearch;
